import { useQuery } from "@tanstack/react-query";
import { Fragment, useMemo } from "react";
import { Alert, Col, ListGroup, ListGroupItem } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";
import { useParams, useSearchParams } from "react-router-dom";
import Laoding from "../../../components/Loading";
import { postMethod } from "../../../function/helper";
import Footer from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";

export default function PayLinkSuccessPage() {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const ids = useMemo(() => {
    const id = params.id;
    if (!id) {
      return [];
    }
    const array = id.split(",");
    if (!Array.isArray(array) || array.length < 1) {
      return [];
    }
    return array;
  }, []);

  const { isFetching, data } = useQuery({
    queryKey: ["PayLinkSuccessPage"],
    queryFn: () =>
      postMethod("/totalpost/v1/payLink/success", { ids }).then(res => {
        if (res && res.status === 200) {
          return res.data.data;
        }

        return res.message;
      }),

    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return (
    <Fragment>
      <Menu />

      <main
        className="flex-grow-1 d-flex flex-column justify-content-center align-items-center p-3 rtl-all"
        style={{ marginTop: 80 }}
      >
        {isFetching && <Laoding />}

        {!isFetching && data.items?.length > 0 && (
          <Col xs={12} sm={6} className="card-shadow p-4 rounded-1 mx-auto">
            <div className="d-flex flex-column justify-content-center align-items-center pb-3">
              <div
                className="border border-secondary rounded-circle d-flex justify-content-center align-items-center"
                style={{ width: 90, height: 90 }}
              >
                <Check color="green" size={80} />
              </div>
              <h3 className="mt-3 text-success text-center">
                پرداخت با موفقیت انجام شد
              </h3>

              <p className="d-flex gap-2 mb-0 py-3 fs-4 align-items-center">
                <span>مبلغ: </span>
                <strong className="fs-2">
                  {data.items
                    .reduce((sum, item) => sum + item.realPayable, 0)
                    .toLocaleString()}
                </strong>
                <span> ریال</span>
              </p>
            </div>

            {data.gateway && (
              <div className="pb-3 d-flex justify-content-center gap-2">
                <span>کد پیگیری: </span>
                <strong>{data.gateway.requestId}</strong>
              </div>
            )}

            <p className="mb-0">لیست سفارشات</p>
            <ListGroup>
              {data.items.map(item => (
                <ListGroupItem key={item.id} className="d-flex flex-wrap gap-3">
                  <div>
                    <span>شماره سفارش: </span>
                    <strong>{item.numberParcel}</strong>
                  </div>

                  <div>
                    <span>نماینده: </span>
                    <strong>
                      {item.agent.user.name} {item.agent.user.family ?? ""}
                    </strong>
                  </div>

                  <div>
                    <span>موبایل: </span>
                    <strong>{item.agent.mobile}</strong>
                  </div>

                  {item.agent.organizationMobile && (
                    <div>
                      <span>موبایل سازمانی: </span>
                      <strong>{item.agent.organizationMobile}</strong>
                    </div>
                  )}

                  <div>
                    <span>مبلغ: </span>
                    <strong>{item.realPayable.toLocaleString()}</strong>
                    <span> ریال</span>
                  </div>
                </ListGroupItem>
              ))}
            </ListGroup>

            <p className="py-3 mb-0">
              لطفا نماینده سفارشات خود را برای پرینت فاکتور و ارسال سفارش، مطلع
              کنید
            </p>
          </Col>
        )}

        {!isFetching && searchParams.get("errors") && (
          <Col xs={12} sm={6}>
            <Alert variant="danger" className="my-2">
              <span>در پرداخت </span>
              <strong>{searchParams.get("errors")}</strong>
              <span> سفارش با خطا مواجه شدیم</span>

              <p className="mb-0">
                لطفا این خطا را با نمایندگی ثبت سفارش، در میان بگذارید
              </p>
            </Alert>
          </Col>
        )}

        {!isFetching && typeof data === "string" && (
          <Col xs={12} sm={6}>
            <Alert variant="danger" className="my-2">
              <p className="mb-0">{data}</p>
              <p className="mb-0">
                لطفا این خطا را با نمایندگی ثبت سفارش، در میان بگذارید
              </p>
            </Alert>
          </Col>
        )}
      </main>
      <Footer />
    </Fragment>
  );
}
